declare global {
    interface Window {
        fbAsyncInit?: () => void;
        FB: {
            init: (options: {
                appId: string;
                cookie: boolean;
                xfbml: boolean;
                version: string;
            }) => void;
            ui: (options: {
                method: string;
                href: string;
            }) => void;
        },

    }
}
const appId = '9094189423967912';
export const initFacebookSdk = () => {

    return new Promise((resolve, reject) => {

        window.fbAsyncInit = () => {
            window.FB.init({
                appId: appId,
                cookie: true,
                xfbml: true,
                version: 'v22.0'
            });
            // Resolve the promise when the SDK is loaded
            resolve(null);
        };

        // Load the Facebook SDK asynchronously
        const fbSdkUrl = 'https://connect.facebook.net/en_US/sdk.js';
        const fbSdkScript = document.createElement('script');
        fbSdkScript.src = fbSdkUrl;
        fbSdkScript.async = true;
        fbSdkScript.defer = true;
        fbSdkScript.crossOrigin = 'anonymous';
        document.body.appendChild(fbSdkScript);     
    });
}

export const shareToFacebook = (url: string) => {
    return new Promise((resolve, reject) => {
        window.FB.ui({
            method: 'share',
            href: url
        });
        resolve(null);
    });
};